import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {CircularProgress} from "@mui/material";

export function ConstantLoaderModal() {
    const top = window.scrollY;
    return (
        <div className='spinner-container' style={{top}}>
            <CircularProgress color="primary" />
        </div>
    )
}

const LoaderModal = observer(() => {
    const {generalStore} = useStores();
    if (!generalStore.isLoaderOpen) {
        return null
    }
    const top = window.scrollY;
    return (
        <div className='spinner-container' style={{top}}>
            <CircularProgress color="primary" />
        </div>
    )
});

export default LoaderModal;
